// Utility to format date to 'Friday, 14 April, 2025'
export function formatLongDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString('en-US', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}

// Utility to format date and time to 'Friday, 14 April, 2025, 02:59 PM'
export function formatLongDateTime(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const datePart = d.toLocaleDateString('en-US', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
  const timePart = d.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
  return `${datePart}, ${timePart}`;
}

// Utility to get the current quarter (1-4) based on the current date
export function getCurrentQuarter(date = new Date()) {
  const month = date.getMonth(); // 0-indexed: Jan = 0
  return Math.floor(month / 3) + 1;
}
